import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {PitRequestCriteriaFilter} from "./pit-request-criteria-filter";
import {PitRequestCriteriaSort} from "./pit-request-criteria-sort";
import {PitRequestCriteriaPage} from "./pit-request-criteria-page";

/** Набор критериев для выборки */

@jsonObject
export class PitRequestHiddenCriteria {

  /** Массив условий фильтрации выборки */
  @jsonArrayMember(PitRequestCriteriaFilter, {emitDefaultValue: false, isRequired: false})
  filters: PitRequestCriteriaFilter[] = [];

  @jsonArrayMember(PitRequestCriteriaSort, {emitDefaultValue: false, isRequired: false})
  sorts: PitRequestCriteriaSort[] = [];


  constructor(fields?: Partial<PitRequestHiddenCriteria>) {
    if (fields)
      Object.assign(this, fields);
  }
}
